















































import { Component, Vue } from "vue-property-decorator";
import { copySolution, getSolution } from "@/services/solutions/solutionService";
import { Solution, CopySolution } from "@/services/solutions/types";
import { copyValidators } from "@/components/channels/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";

@Component({
    directives: {
        validate
    }
})
export default class SolutionCopyModal extends Vue {
    solution = {} as Solution;
    model = {} as CopySolution;
    validators = copyValidators;

    open(solutionId: string) {
        getSolution(solutionId).then(response => {
            this.solution = response;
            this.model.solutionId = solutionId;
            this.model.copyUserAccess = false;
            this.model.name = this.solution.name + " Copy";
            this.$bvModal.show("modal-solutionCopy");
        });
    }

    async confirm() {
        if (!await validateForm([this.validators])) return;
        this.$bvModal.hide("modal-solutionCopy");
        copySolution(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopySolution;
    }

    decline() {
        this.$bvModal.hide("modal-solutionCopy");
    }
}
